/* ══════════════════════════════════════════════════════════════════════════
   F24 · PDP PK-EASY v3 — comportamiento de las secciones f24-pk-*
   Portado del mockup aprobado (mockup_FINAL.html, 6-ago-2026).

   Diferencias contra el mockup, a propósito:
   · NO se hace  documentElement.className = 'js'.  Eso BORRA las clases que
     Horizon ya puso en <html>. Se agrega una clase con classList.add().
   · "Agregar al carrito" agrega de verdad contra /cart/add.js. El <form>
     nativo sigue ahí: si el JS falla, el POST normal a /cart/add funciona.
   · La barra fija publica su altura en  --f24-atc-h, que es el contrato que
     ya usan los FAB de WhatsApp y del asesor en el layout para levantarse y
     no comerse el tap del botón de compra.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Cada sección f24-pk-* trae su propio <script src>, así que este archivo se
     ejecuta una vez POR SECCIÓN (7 veces en la plantilla completa). Sin este
     candado se duplican los listeners de submit —un clic mandaría 7 altas al
     carrito— y se acumulan 7 setInterval. Se arranca una sola vez. */
  if (window.__f24pkBooted) return;
  window.__f24pkBooted = true;

  document.documentElement.classList.add('f24pk-js');

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) {
    return Array.prototype.slice.call((c || document).querySelectorAll(s));
  };
  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot() {

    /* ── galería: puntos + miniaturas ─────────────────────────────────── */
    $$('[data-pk-gal]').forEach(function (gal) {
      var rail = $('[data-pk-rail]', gal);
      if (!rail) return;
      var dots = $$('[data-pk-dot]', gal);
      var minis = $$('[data-pk-mini]', gal);

      function mark(i) {
        dots.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        minis.forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      }
      function go(i) {
        var target = rail.clientWidth * i;
        mark(i);
        try { rail.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' }); }
        catch (e) { rail.scrollLeft = target; }
        /* si el scroll suave no avanzó (rAF congelado), se coloca a la fuerza */
        setTimeout(function () {
          if (Math.abs(rail.scrollLeft - target) > 4) rail.scrollLeft = target;
        }, 420);
      }
      dots.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
      minis.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });

      var tk;
      rail.addEventListener('scroll', function () {
        clearTimeout(tk);
        tk = setTimeout(function () {
          mark(Math.round(rail.scrollLeft / rail.clientWidth));
        }, 70);
      }, { passive: true });
    });

    /* ── cantidad ─────────────────────────────────────────────────────── */
    $$('[data-pk-qty]').forEach(function (box) {
      var input = $('input', box);
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var max = parseInt(input.getAttribute('max'), 10) || 99;
      function setq(n) {
        if (isNaN(n)) n = min;
        input.value = Math.max(min, Math.min(max, n));
      }
      var less = $('[data-pk-less]', box), more = $('[data-pk-more]', box);
      if (less) less.addEventListener('click', function () { setq(parseInt(input.value, 10) - 1); });
      if (more) more.addEventListener('click', function () { setq(parseInt(input.value, 10) + 1); });
      input.addEventListener('change', function () { setq(parseInt(input.value, 10)); });
    });

    /* ── acordeones ───────────────────────────────────────────────────── */
    $$('[data-pk-acc] .head').forEach(function (h) {
      var panel = h.nextElementSibling;
      if (!panel) return;
      h.addEventListener('click', function () {
        var open = h.getAttribute('aria-expanded') === 'true';
        h.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          void panel.offsetHeight;          /* reflujo forzado: rAF no es de fiar */
          panel.style.height = '0px';
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          setTimeout(function () {
            if (h.getAttribute('aria-expanded') === 'true') panel.style.height = 'auto';
          }, 320);
        }
      });
    });

    /* ── agregar al carrito de verdad ─────────────────────────────────── */
    /* Avisa al tema que el carrito cambió, con el payload que Horizon espera.

       Historia (10-ago-2026). Antes esto tocaba el globito a mano y NO despachaba
       'cart:update', con esta razón escrita: "sus propios listeners esperan un
       payload con detail.data.sections y al recibir el nuestro reventaban con
       TypeError: Cannot read properties of undefined (reading 'sections')".

       El diagnóstico estaba a medias. El consumidor real lee
         event.detail.data.sections?.[this.sectionId]
       La  ?.  cubre a  sections,  pero NO a  data:  el evento reventaba por ir
       SIN la llave  data,  no por despacharlo. Con el payload bien formado,
       cart-items-component se re-renderiza solo (sectionRenderer, porque
       sections va vacío) y cart-icon actualiza el globito por su cuenta.

       Y tocar el globito a mano era destructivo: escribía textContent sobre el
       contenedor del globito, que es el PADRE del <span ref="cartBubbleCount">.
       Al asignar textContent se borraba ese hijo, el MutationObserver de
       <cart-icon> volvía a buscar sus refs y tronaba con
         Required ref "cartBubbleCount" not found in component cart-icon
       Desde la PRIMERA alta el ícono y el panel del carrito quedaban muertos
       hasta recargar. Ése era el bug por el que el drawer abría diciendo
       "Tu carrito está vacío" con el producto ya dentro. */
    function notifyCartUpdate() {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          try {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: 'f24-pdp',
                data: { source: 'f24-pdp', itemCount: cart.item_count, sections: {} }
              }
            }));
          } catch (e) { /* el aviso jamás debe tumbar la compra */ }
        })
        .catch(function () { });
    }

    $$('form.f24pk-form').forEach(function (form) {
      form.addEventListener('submit', function (ev) {
        var btn = $('[data-pk-add]', form);
        if (!window.fetch || !btn) return;      /* sin fetch: POST nativo */
        ev.preventDefault();
        var original = btn.getAttribute('data-label') || btn.innerHTML;
        btn.setAttribute('data-label', original);
        btn.disabled = true;
        btn.innerHTML = 'Agregando…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed ' + r.status);
            return r.json();
          })
          .then(function () {
            btn.innerHTML = 'Agregado ✓';
            notifyCartUpdate();
            setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1800);
          })
          .catch(function () {
            /* red de seguridad: si la API falla, se manda el formulario normal */
            btn.innerHTML = original;
            btn.disabled = false;
            form.submit();
          });
      });
    });

    /* ── barra fija + reveal ──────────────────────────────────────────────
       Todo por scroll directo con getBoundingClientRect: el
       IntersectionObserver no dispara cuando la pestaña abre en segundo plano
       y dejaba media página invisible; requestAnimationFrame queda congelado
       por el mismo motivo. Además hay dos redes de seguridad por tiempo. */
    var sticky = $('[data-pk-sticky]');
    var anchor = $('[data-pk-add]');
    var cierre = $('[data-pk-cierre]');
    var pend = $$('.f24pk .rv');

    function setAtcVar(on) {
      var h = on && sticky ? sticky.offsetHeight : 0;
      document.documentElement.style.setProperty('--f24-atc-h', h + 'px');
    }

    function tick() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = pend.length - 1; i >= 0; i--) {
        var r = pend[i].getBoundingClientRect();
        /* sin tope por abajo: con un salto de scroll grande (ancla, restaurar
           posición, rueda rápida) un bloque puede cruzar la pantalla entera
           entre dos mediciones y se quedaría invisible para siempre */
        if (r.top < vh * 0.93) { pend[i].classList.add('in'); pend.splice(i, 1); }
      }
      if (!sticky || !anchor) return;
      var b = anchor.getBoundingClientRect();
      var cierreALaVista = false;
      if (cierre) {
        var cr = cierre.getBoundingClientRect();
        cierreALaVista = cr.top < vh - 80 && cr.bottom > 0;
      }
      var on = b.bottom < 0 && !cierreALaVista;
      if (sticky.classList.contains('on') !== on) {
        sticky.classList.toggle('on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        setAtcVar(on);
      }
    }
    /* red de seguridad: nada que esté a la vista puede quedarse en opacity 0 */
    function rescue() {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      for (var i = pend.length - 1; i >= 0; i--) {
        var r = pend[i].getBoundingClientRect();
        if (r.top < vh * 1.8 && r.bottom > -vh) { pend[i].classList.add('in'); pend.splice(i, 1); }
      }
    }
    function revealAll() { $$('.f24pk .rv').forEach(function (el) { el.classList.add('in'); }); pend = []; }

    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    window.addEventListener('load', tick);
    window.addEventListener('pageshow', function () { tick(); rescue(); });
    document.addEventListener('visibilitychange', function () { tick(); rescue(); });
    /* latido de respaldo: si el navegador no entrega el evento scroll —pestaña
       abierta en segundo plano, rAF congelado— esto igual destapa el contenido */
    setInterval(tick, 220);
    if (reduce) { revealAll(); tick(); }
    else { tick(); setTimeout(tick, 120); setTimeout(tick, 600); setTimeout(rescue, 2200); }

    /* ── ir a un bloque ───────────────────────────────────────────────── */
    $$('[data-goto]').forEach(function (el) {
      el.addEventListener('click', function (ev) {
        ev.preventDefault();
        var t = $(el.getAttribute('data-goto'));
        if (!t) return;
        closeFit();
        var y = Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - 70);
        try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); }
        catch (err) { window.scrollTo(0, y); }
        setTimeout(function () {
          if (Math.abs(window.pageYOffset - y) > 60) window.scrollTo(0, y);
          tick();
        }, 560);
        if (el.hasAttribute('data-pk-goadd') && anchor) {
          setTimeout(function () { anchor.focus({ preventScroll: true }); }, reduce ? 0 : 520);
        }
      });
    });

    /* ── modal de compatibilidad ──────────────────────────────────────── */
    var fit = $('[data-pk-fit]');
    var lastFocus = null;
    function openFit() {
      if (!fit) return;
      lastFocus = document.activeElement;
      fit.classList.add('on');
      document.body.style.overflow = 'hidden';
      var x = $('.x', fit); if (x) x.focus();
    }
    function closeFit() {
      if (!fit || !fit.classList.contains('on')) return;
      fit.classList.remove('on');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    $$('[data-pk-openfit]').forEach(function (b) { b.addEventListener('click', openFit); });
    if (fit) {
      $$('[data-close]', fit).forEach(function (b) { b.addEventListener('click', closeFit); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeFit();
      });
      var verdict = $('[data-pk-verdict]', fit);
      $$('input[type="checkbox"]', fit).forEach(function (c) {
        c.addEventListener('change', function () {
          if (!verdict) return;
          var n = $$('input[type="checkbox"]:checked', fit).length;
          var t;
          if (n === 0) t = '<b>Marca lo que aplique</b>Con esas cuatro respuestas te decimos de frente si este equipo es para ti o si te conviene otro.';
          else if (n <= 2) t = '<b>Puede que sí, puede que no</b>Escríbenos por WhatsApp con lo que te falta y te decimos si este equipo te resuelve o si te conviene uno bajo tarja.';
          else if (n === 3) t = '<b>Va bien contigo</b>Cumples con casi todo. Revisa el punto que dejaste sin marcar antes de comprar y, si tienes duda, escríbenos.';
          else t = '<b>Es justo lo que buscas</b>Cumples con los cuatro puntos. Este equipo se pone en la barra y funciona desde el primer día, sin obra y sin plomero.';
          verdict.innerHTML = t;
        });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
